import { render, staticRenderFns } from "./aFeeDetailConfig.vue?vue&type=template&id=01ae232f&scoped=true"
import script from "./aFeeDetailConfig.vue?vue&type=script&lang=js"
export * from "./aFeeDetailConfig.vue?vue&type=script&lang=js"
import style0 from "./aFeeDetailConfig.vue?vue&type=style&index=0&id=01ae232f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae232f",
  null
  
)

export default component.exports